export const Attendance = {
    attence:{
        '考勤':'Attence',
        '传统考勤':'tradition',
        '数字考勤':'digital',
        'GPS考勤':'GPS',
        '二维码考勤':'QR code',
        "扫码考勤":"QR code",
        '签入签出考勤':'CheckIn and out',
        '系统提示':'System reminder',
        '本次考勤为扫码考勤':'本次考勤为扫码考勤，请您用微信扫一扫老师的大屏幕的二维码进行签到',
        '签到成功':'Check in succeeded',
        '签出成功':'Check out successful',
        '未到签出时间':'Check out time has not arrived',
        '还未到签出时间':"It's not time to check out",
        '此时签出视为早退':'At this time, check out is regarded as leaving early',
        "新建考勤":"New Attendance",
        "考勤名称":"Attendance name",
        "请输入考勤名称":"Please enter the attendance name",
        "选择考勤方式":"Select attendance method",
        "编辑考勤名称":"Edit Attendance Name",
        "编辑考勤":"Edit",
        "删除考勤":"Delete",
        "查看GPS与可疑代签":"Check GPS and suspicious",
        "取消考勤":"Cancel",
        "确定要删除本次考勤吗":"Are you sure you want to delete this attendance?",
        "异常签到":"Abnormal",
        "可疑代签":"Suspicious",
        "GPS":"GPS",
        "无异常签到成员":"No abnormal sign in member",
        "学员信息":"Student",
        "考勤状态":"State",
        "可疑代签情况":"Suspicious",
        "同账号多设备登录":"Multi device login with the same account",
        "没有发现代签的学生":"No student signed on behalf！",
        "暂无学生GPS签到记录":"No student GPS sign in record",
        "签到正常":"normal",
        "放弃":"Give up",
        "结束":"End",
        "结束并完成此次考勤":"End and complete this attendance?",
        "考勤结束后老师可手动修改未签到学生考勤状态":"After the attendance is completed, the teacher can manually modify the attendance status of the students who have not signed in.",
        "放弃此次考勤":"Give up this attendance?",
        "放弃此次考勤后此次考勤数据将清零":"After giving up this attendance, the attendance data will be reset.",
        "学生通过以下数字完成签到":"Students sign in with the following numbers",
        "更换一个":"Replace",
        "学生通过微信扫一扫该二维码完成签到":"Students can scan the QR code through WeChat to sign in",
        "签到时间":"sign time",
        "签到人":"sign name",
        "请选择考勤方式":"Please select an attendance method",
    },
    status: {
        '全部': 'whole',
        '旷课': 'Absence',
        '出勤': 'Attendance',
        '缺勤': 'Absence',
        '迟到': 'Late',
        '请假': 'Leave',
        '早退': 'Leave early',
        '事假': 'Compassionate leave',
        '病假': 'Sick leave',
        '公假': 'Public holiday',
        '待签到':'wait for sign',
    },
    checkInCheckOut:{
        '签入迟到':'Check in late',
        '签入考勤':'Check in',
        '签出考勤':'Check out',
        '签到':'Sign in',
        "考勤时长":"Duration",
        "考勤结果":"Results",
        "小时":" hours",
        "分钟":"minutes",
        "分钟后考勤自动结束":"minutes later, the attendance automatically end",
        "下次考勤时间":"Next attendance time",
        "到时自动通知考勤":"Automatic notification of attendance at that time",
        "请设置":"Please set",
        "开始考勤":"Start attendance",
        "请输入持续考勤时间":"Please enter the continuous attendance time",
        "请选择下次考勤时间":"Please select the next attendance time"
    },
    checkInCodeResult:{
        '签到失败':'Check in failed',
        '此签到二维码已过期失效':'This check-in QR code has expired, please scan it again',
        '签到二维码签到':'Sign in: QR code sign in',
        '重新扫码':'Rescan code',
        '该考勤不是二维码考勤':'This attendance is not a two-dimensional code attendance and cannot be scanned for sign in',
        '返回考勤列表':'Return to attendance list',
        '本次考勤已结束':'This attendance has ended, and sign in cannot be completed',
        '老师已停止加课':"The teacher has stopped join classes. You can't sign in for the course",
        '具体情况请咨询任课老师':'Please consult the teacher for details',
        '无效签到':'Invalid sign in',
        '您是课程老师':'You are a course teacher, so you do not need to attend the course',
        '您是该课程老师助教':'You are the teacher / Assistant of the course, so you do not need to attend the course',
        '本课程人数已达到设定的课程人数上限':'The number of students in this course has reached the set maximum number of students. You',
        '无法加入课程进行签到':'unable to sign in for the course. Please consult the teacher for details',
        '返回课程列表':'Return to course list',
        '恭喜您签到成功':'Successful check-in',
        '您可在考勤列表页查看考勤结果':'You can view the attendance results on the attendance list page',
        '同时您已成功加入课程':'At the same time, you have successfully joined the course',
        '重复签到':'Repeat check-in',
        '您已参与过本次扫码签到':'You have participated in this code scanning check-in, and the check-in result will be',
        '首次签到时间为准':'the first check-in time shall prevail. You can view it in the attendance list',
        '本次考勤已被删除':'This attendance has been deleted',
        '未知原因':'Unknown reason, please check in again',
        '访问不合法':'Illegal access',
        '请您用微信扫一扫老师的大屏幕的二维码':"Please use wechat to scan the QR code on the teacher's big screen to complete the check-in",
        '知道啦':'Ok',
        '签到结果':"Check in result",
        '仅已认证身份并在选课名单中的成员才能参与本次考勤':'Only members who have been authenticated and are in the course selection list can participate in this attendance. Please authenticate your identity first and verify with the teacher whether this account is in the course selection list',
        '请输入数字':'Please enter the number',
        '数字由老师处获取':'The number is obtained from the teacher',
        '点击签到':'Click sign in',
        '定位准确':'Accurate positioning',
        '定位错误':'Positioning error',
        '重新定位':'Repositioning',
        "正在定位中":"Locating...",
        "定位失败没有权限获取到地理位置请先开启GPS并且授权软件使用!这样可以提高定位的准确度":"Positioning failed. You do not have permission to obtain the geographic location. Please turn on GPS and authorize the software to use it! This can improve the accuracy of positioning",
        "通过微信获取地理位置信息成功":"Successful access to geographical location information through WeChat...",
        "GPS位置信息获取失败您是否还要继续签到如果您继续签到的话老师那边将会显示异常签到":"GPS location information acquisition failed. Do you want to continue to sign in? If you continue to sign in, the teacher will display abnormal sign in!",
        "需要重新定位如果位置持续不准确可能您未打开GPS和授权允许":"Need to relocate? If the location continues to be inaccurate, you may not have turned on GPS and authorized permission",
        "正在重新定位中":"Relocating...",
        "通过微信成功获取GPS地理位置信息":"Successfully obtained GPS geographic location information through WeChat",
        "通过微信地理位置坐标转换完毕":"Through WeChat, geographic location coordinate conversion is completed",

    },
    "考勤持续时间":"Attendance duration",

}